import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, TrendingUp, TrendingDown, Trash2 } from "lucide-react";

export default function AssetActiveAlerts({ alerts, onDelete }) {
  if (alerts.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="mb-8"
    >
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2" style={{ fontFamily: 'Unbounded' }}>
            <Bell className="w-5 h-5 text-[#F59E0B]" />
            ACTIVE ALERTS
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {alerts.map((alert) => (
              <div
                key={alert.id}
                data-testid={`alert-${alert.id}`}
                className="flex items-center justify-between glass-effect p-4 rounded-lg"
              >
                <div className="flex items-center gap-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${alert.condition === 'above' ? 'bg-[#00FFA3]/10' : 'bg-[#FF3B30]/10'}`}>
                    {alert.condition === 'above'
                      ? <TrendingUp className="w-5 h-5 text-[#00FFA3]" />
                      : <TrendingDown className="w-5 h-5 text-[#FF3B30]" />}
                  </div>
                  <div>
                    <div className="text-white font-semibold">
                      Alert when price goes {alert.condition}
                    </div>
                    <div className="text-gray-400 text-sm mono">
                      Target: ${alert.target_price.toLocaleString()}
                    </div>
                  </div>
                </div>
                <Button
                  data-testid={`delete-alert-${alert.id}-btn`}
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(alert.id)}
                  className="text-gray-500 hover:text-[#FF3B30] hover:bg-[#FF3B30]/10"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
